import React from 'react';
import './AboutOverview.scss';

const AboutOverview: React.FC = () => {
  return (
    <div className="about-overview-container">
      <div className="overview-header">
        <h1>About Florida First Psychiatry</h1>
        <p>Compassionate, evidence-based mental health care for adults in Tallahassee, Florida</p>
      </div>

      <div className="overview-content">
        <section className="overview-section">
          <h2>Our Mission</h2>
          <p>
            At Florida First Psychiatry, our mission is to provide compassionate, comprehensive, and individualized psychiatric care. 
            We strive to empower our patients by offering effective treatments and support, enabling them to lead fulfilling lives. 
            We are committed to supporting our patients through their mental health journey with professionalism, empathy, and evidence-based care.
          </p>
        </section>

        <section className="overview-section">
          <h2>Who We Are</h2>
          <p>
            Florida First Psychiatry is a dedicated mental health practice located in Tallahassee, Florida, committed to providing 
            comprehensive psychiatric care to individuals seeking support for various mental health conditions. Our team of experienced 
            professionals is dedicated to delivering compassionate and personalized care tailored to each patient's unique needs.
          </p>
          <p>
            We understand that mental health is a vital component of overall well-being, and we are here to support you every step 
            of the way. Whether you're dealing with depression, anxiety, bipolar disorder, PTSD, ADHD, or other mental health conditions, 
            we provide expert evaluation, treatment, and ongoing support.
          </p>
        </section>

        <section className="overview-section">
          <h2>Our Approach</h2>
          <p>
            At Florida First Psychiatry, we believe in a patient-centered approach to mental health care. We take the time to understand 
            your unique situation, concerns, and goals. Our comprehensive evaluations form the foundation of personalized treatment plans 
            that may include medication management, psychotherapy, and innovative treatments like Transcranial Magnetic Stimulation (TMS).
          </p>
          <p>
            We value collaboration and believe that the best outcomes are achieved when patients are actively involved in their treatment 
            decisions. Our providers are thoughtful listeners who are passionate about helping patients create personal outlooks that 
            promote mental well-being.
          </p>
        </section>

        <section className="overview-section">
          <h2>Why Choose Florida First Psychiatry</h2>
          <div className="features-grid">
            <div className="feature-item">
              <h3>Experienced Providers</h3>
              <p>Our team includes board-certified psychiatrists and psychiatric nurse practitioners with extensive experience in treating a wide range of mental health conditions.</p>
            </div>
            <div className="feature-item">
              <h3>Comprehensive Care</h3>
              <p>We offer a full spectrum of psychiatric services, from initial evaluations to medication management, therapy, and advanced treatments like TMS.</p>
            </div>
            <div className="feature-item">
              <h3>Patient-Centered</h3>
              <p>We prioritize each patient's individual needs, ensuring personalized treatment plans that respect your unique circumstances and goals.</p>
            </div>
            <div className="feature-item">
              <h3>Flexible Options</h3>
              <p>We offer both in-office and telehealth appointments to accommodate your schedule and preferences, making quality care accessible and convenient.</p>
            </div>
            <div className="feature-item">
              <h3>Evidence-Based</h3>
              <p>All our treatments are grounded in the latest research and clinical evidence, ensuring you receive the most effective care available.</p>
            </div>
            <div className="feature-item">
              <h3>Compassionate Care</h3>
              <p>We understand that seeking mental health care can be challenging, and we're committed to providing a supportive, non-judgmental environment.</p>
            </div>
          </div>
        </section>

        <section className="overview-section">
          <h2>Our Commitment</h2>
          <p>
            When asked what inspired the founding of Florida First Psychiatry, our founder Dr. Prasanti Tatini responded, 
            "I wanted to put myself in a position to be able to prioritize each of my patients' needs." This philosophy 
            continues to guide everything we do.
          </p>
          <p>
            We are committed to making quality mental health care accessible, personalized, and effective. Your mental health 
            journey matters to us, and we're here to partner with you every step of the way toward improved well-being and 
            a more fulfilling life.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutOverview;

